import m from 'mithril';

const LoadingIndicator: m.Component<{colorScheme?:string, message?:string}> = {
    view: function(vnode) {
        let color = (vnode.attrs.colorScheme == null)? 'primary' : vnode.attrs.colorScheme;
        
        return [
            m("div", {class: "d-flex justify-content-center mt-5"}, 
                m("div", {class: "spinner-border text-" + color, role: "status"}, [
                    m("span", {class: "sr-only"}, "Loading...")
                ])
            ),
            (vnode.attrs.message)?
            m("div.mt-3", {class:"text-center"}, vnode.attrs.message): null
        ]
    }
}

export default LoadingIndicator;